import NotificationAlert from "react-notification-alert";
import MaterialReactTable from "material-react-table";
import { t } from 'react-multi-lang';
import { MRT_Localization_FR } from "material-react-table/locales/fr";
import { MRT_Localization_EN } from "material-react-table/locales/en";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import React, { useEffect, useCallback, useState } from "react";
import { fetchSimulationCGro } from "../../Redux/simulationCReduce";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";

// core components
function SimulationCGro({client}) {
  document.title = "Liste des Simulations commerciale";
  const dispatch = useDispatch();
  const navigate = useHistory();
  const [alert, setAlert] = React.useState(null);
  let lang = window.localStorage.getItem("lang");
  const notificationAlertRef = React.useRef(null);
  const [entities, setEntities] = React.useState([]);
  const [loader, setLoader] = React.useState(true);
  const notify = (place, msg, type) => {
    var options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>
            {msg}
          </div>
        </div>
      ),
      type: type,
      icon: "nc-icon nc-bell-55",
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };


  const [columns] = useState([
    {
      header: "Code Grossiste",
      accessorKey: "grossistes.Code_client"
    },
    {
      header: "Grossiste",
      accessorKey: "grossistes.Raison_sociale"
    },
    {
      header: "Type",
      accessorKey: "simulation_commerciales.type"
    },
    {
      accessorKey: 'id',
      header: 'Détails',
      Cell: ({ cell, row }) => (
        <div className="actions-right block_action">
          <Button
            className=" mr-1 float-left"
            type="button"
            variant="info"
            onClick={() => {
              navigate.push(client + "/commandesimulation/detail/" + cell.row.original.simulation_commerciales.id_entete+"/"+cell.row.original.grossistes.id);
            }}
          >
            <i className="fas fa-eye"></i>
          </Button>
        </div>
      ),
    },
    // {
    //   accessorKey: 'id',
    //   header: 'Actions',
    //   Cell: ({ cell, row }) => (
    //     <div className="actions-right block_action">
    //       <Button
    //         id={"idLigne_" + cell.row.original.id}
    //         onClick={(e) => {
    //           verif(cell.row.original.id)
    //         }}
    //         variant="danger"
    //         size="sm"
    //         className="text-danger btn-link delete"
    //       >
    //         <i className="fa fa-trash" id={"idLigne_" + cell.row.original.id} />
    //       </Button>
    //     </div>
    //   ),
    // },
  ])

  const hideAlert = () => {
    setAlert(null);
  };

  const confirmMessage = (id, e, test) => {
    setAlert(
      test === 1 ? (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title="Êtes-vous sûr de continuer la suppression ? "
          onConfirm={() => deletesimulationC(id, e)}
          onCancel={() => hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Oui"
          cancelBtnText="Non"
          showCancel
        />
      ) : (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title="Êtes-vous sûr de continuer la suppression ? "
          onConfirm={() => deletesimulationC(id, e)}
          onCancel={() => hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Oui"
          cancelBtnText="Non"
          showCancel
        />
      )
    );
  };


  function verif(id, e) {   
    
      confirmMessage(id, e,1)
 
  }


  function deletesimulationC(id, e) {
    dispatch(simulationCDeleted({ id })).then((val) => {
      notify("tr", "Simulation supprimé avec succées","success")
      getSimulation()
      hideAlert();
    });
  }

  function ListTable({ list, loader }) {
    return (
      <MaterialReactTable
        state={{ isLoading: loader }}
        columns={columns}
        data={list}
        enableColumnActions={true}
        enableColumnFilters={true}
        enablePagination={true}
        enableSorting={true}
        enableBottomToolbar={true}
        enableTopToolbar={true}
        muiTableBodyRowProps={{ hover: false }}
        displayColumnDefOptions={{
          'mrt-row-numbers': {
            size: 10,
          },
          'mrt-row-expand': {
            size: 10,
          },
        }}
        enableColumnFilterModes
        initialState={{
          columnVisibility: { description: false },
          density: 'compact',
          showGlobalFilter: true,
        }}
        muiSearchTextFieldProps={{
          placeholder: t("search"),
          sx: { minWidth: '18rem' },
          variant: 'outlined',
        }}

        filterFns={{
          myCustomFilterFn: (row, id, filterValue) => {
            const value = row.getValue(id);
            return typeof value === 'string' && value.toLowerCase().includes(filterValue.toLowerCase());
          },
        }}
        globalFilterFn="myCustomFilterFn"

        localization={
          lang === "fr"
            ? MRT_Localization_FR
            : MRT_Localization_EN
        }
      />
    );
  }

  const getSimulation = useCallback(async () => {
    var marche = await dispatch(fetchSimulationCGro({client}));
    setEntities(marche.payload);
    setLoader(false)
  }, [dispatch]);
  useEffect(() => {
    getSimulation()
  }, [getSimulation]) //now shut up eslint
  return (
    <>
      <Container fluid>
        {alert}
        <div className="rna-container">
          <NotificationAlert ref={notificationAlertRef} />
        </div>
        <Row>
     
          <Col md="12">

            <Card>
              <Card.Header>
                <Card.Title as="h4">Liste des simulations</Card.Title>
              </Card.Header>
              <Card.Body className="table-style">
                <ListTable list={entities} loader={loader} ></ListTable>
              </Card.Body>
            </Card>
          </Col>

        </Row>
      </Container>
    </>
  );
}

export default SimulationCGro;
